import { isNumber } from "lodash";
import * as constants from "./constants";
// Helper functions for data manipulation

export const getMetaScoresDbs = (databases) =>
  databases?.filter((db) => db?.isMeta);

export const getIndividualDbs = (databases) =>
  databases.filter((db) => !db?.isMeta);

export const getPremiumDbs = (databases) =>
  databases.filter((db) => db.isPremium);

export const getPathogenicDbs = (databases) =>
  databases.filter((db) => db.pathogenicity === "Pathogenic");

export const getUncertainDbs = (databases) =>
  databases.filter((db) => db.pathogenicity === "Uncertain");

export const getBenignDbs = (databases) =>
  databases.filter((db) => db.pathogenicity === "Benign");

export const countPathogenicDbsSum = (databases) => {
  const a = databases.filter((db) => db.pathogenicity === "Pathogenic");
  const sum = a.reduce((s, i) => {
    let value = 0;
    if (i.strength === "Very Strong") {
      value = 8;
    }
    if (i.strength === "Strong") {
      value = 4;
    }
    if (i.strength === "Moderate") {
      value = 2;
    }
    if (i.strength === "Supporting") {
      value = 1;
    }
    return s + value;
  }, 0);
  return sum;
};

export const countBenignDbsSum = (databases) => {
  const a = databases.filter((db) => db.pathogenicity === "Benign");
  const sum = a.reduce((s, i) => {
    let value = 0;
    if (i.strength === "Very Strong") {
      value = 8;
    }
    if (i.strength === "Strong") {
      value = 4;
    }
    if (i.strength === "Moderate") {
      value = 2;
    }
    if (i.strength === "Supporting") {
      value = 1;
    }
    return s + value;
  }, 0);
  return sum;
};

export const countUncertainDbsSum = (databases) => {
  const a = databases.filter((db) => db.pathogenicity === "Uncertain");
  const sum = a.length;
  return sum;
};

export const getDannDataIsAvailable = (databases) => {
  const dbsFound = databases.filter((db) => db.name === "DANN");
  if (dbsFound?.[0]?.scores?.length > 0) return true;
  return false;
};

const dbnsfpDatabases = [
  "SIFT",
  "SIFT4G",
  "PROVEAN",
  "MVP",
  "MutPred",
  "PrimateAI",
  "BayesDel noAF",
  "BayesDel addAF",
  "LIST-S2",
  "MutationTaster",
  "Mutation assessor",
  "FATHMM",
  "FATHMM-MKL",
  "FATHMM-XF",
  "EIGEN",
  "EIGEN PC",
  "LRT",
  "DEOGEN2",
  "M-CAP",
  "MetaLR",
  "MetaSVM",
  "MetaRNN",
  "REVEL",
];

export const getDbnsfpDataIsAvailable = (databases) => {
  const dbsFound = databases.filter((db) => dbnsfpDatabases.includes(db.name));
  return dbsFound.map((item) => item.scores).some((elem) => elem?.length > 0);
};

export const calculateCalibratedPrediction = (score, databaseThresholds) => {
  if (
    isNumber(databaseThresholds?.pathogenicThresholdVeryStrong) &&
    score >= databaseThresholds.pathogenicThresholdVeryStrong
  ) {
    return constants.pathogenicVeryStrong;
  }
  if (
    isNumber(databaseThresholds?.pathogenicThresholdStrong) &&
    score < databaseThresholds.pathogenicThresholdVeryStrong &&
    score >= databaseThresholds.pathogenicThresholdStrong
  ) {
    return constants.pathogenicStrong;
  }
  if (
    isNumber(databaseThresholds?.pathogenicThresholdModerate) &&
    isNumber(databaseThresholds?.pathogenicThresholdStrong) &&
    score < databaseThresholds.pathogenicThresholdStrong &&
    score >= databaseThresholds.pathogenicThresholdModerate
  ) {
    return constants.pathogenicModerate;
  }
  if (
    isNumber(databaseThresholds?.pathogenicThresholdSupporting) &&
    isNumber(databaseThresholds?.pathogenicThresholdModerate) &&
    score < databaseThresholds.pathogenicThresholdModerate &&
    score >= databaseThresholds.pathogenicThresholdSupporting
  ) {
    return constants.pathogenicSupporting;
  }
  if (
    isNumber(databaseThresholds?.benignThresholdSupporting) &&
    score <= databaseThresholds.benignThresholdSupporting &&
    score > databaseThresholds.benignThresholdModerate
  ) {
    return constants.benignSupporting;
  }
  if (
    isNumber(databaseThresholds?.benignThresholdModerate) &&
    score <= databaseThresholds.benignThresholdModerate &&
    score > databaseThresholds.benignThresholdStrong
  ) {
    return constants.benignModerate;
  }
  if (
    isNumber(databaseThresholds?.benignThresholdStrong) &&
    score <= databaseThresholds.benignThresholdStrong &&
    score > databaseThresholds.benignThresholdVeryStong
  ) {
    return constants.benignStrong;
  }
  if (
    isNumber(databaseThresholds?.benignThresholdVeryStong) &&
    score <= databaseThresholds.benignThresholdVeryStong
  ) {
    return constants.benignVeryStrong;
  }
  return constants.uncertain;
};
